<form [formGroup]="passwordsForm">
  <!-- * Contraseña -->
  <ion-item
    mode="md"
    lines="none"
    color="gray"
    class="mpe-input-square-floating"
  >
    <ion-label position="floating" mode="md" color="status-icon-enable">
      <ion-text mode="md" color="danger">
        {{ "Forms.asterisk" | translate }}
      </ion-text>
      {{ "Labels.password" | translate }}
    </ion-label>

    <ion-input
      [type]="passwordVisible ? 'text' : 'password'"
      formControlName="password"
      [attr.data-test]="'Automation.txtbox-profile-new-password' | translate"
      id="password"
      mode="ios"
      color="medium"
      minlength="8"
      maxlength="12"
      debounce="200"
      required
      [ngClass]="
        (passwordsForm.get('password').value | isNullEmpty)
          ? 'border-base'
          : passwordsForm.get('password').invalid
          ? 'border-danger'
          : 'border-valid'
      "
    ></ion-input>

    <ion-button
      class="mpe-button-icon-circle mpe-no-padding mpe-eye-button"
      size="default"
      mode="md"
      shape="round"
      color="white"
      fill="clear"
      (click)="passwordVisible = !passwordVisible"
    >
      <ion-icon
        color="status-icon-enable"
        slot="icon-only"
        [name]="passwordVisible ? 'eye-off' : 'eye'"
      ></ion-icon>
    </ion-button>
  </ion-item>

  <!-- * Formato Contraseña -->
  <ion-row class="content-password-format">
    <app-password-format
      [password]="passwordsForm.get('password').value"
    ></app-password-format>
  </ion-row>

  <hr class="separator-gray-dashed" />

  <!-- * Confirmar contraseña -->
  <ion-item
    mode="md"
    lines="none"
    color="gray"
    class="mpe-input-square-floating"
  >
    <ion-label position="floating" mode="md" color="status-icon-enable">
      <ion-text mode="md" color="danger">
        {{ "Forms.asterisk" | translate }}
      </ion-text>
      {{ "Labels.password-confirm" | translate }}
    </ion-label>

    <ion-input
      [type]="passwordConfirmVisible ? 'text' : 'password'"
      formControlName="passwordConfirm"
      [attr.data-test]="'Automation.txtbox-profile-password-confirm' | translate"
      id="password"
      mode="ios"
      color="medium"
      minlength="8"
      maxlength="12"
      debounce="200"
      required
      [ngClass]="
        (passwordsForm.get('passwordConfirm').value | isNullEmpty)
          ? 'border-base'
          : passwordsForm.get('passwordConfirm').invalid
          ? 'border-danger'
          : 'border-valid'
      "
    ></ion-input>

    <ion-button
      class="mpe-button-icon-circle mpe-no-padding mpe-eye-button"
      [attr.data-test]="'Automation.btn-profile-new-password-accept' | translate"
      size="default"
      mode="md"
      shape="round"
      color="white"
      fill="clear"
      (click)="passwordConfirmVisible = !passwordConfirmVisible"
    >
      <ion-icon
        color="status-icon-enable"
        slot="icon-only"
        [name]="passwordConfirmVisible ? 'eye-off' : 'eye'"
      ></ion-icon>
    </ion-button>
  </ion-item>

  <!-- * Match pass -->
  <ion-row class="content-password-format">
    <ion-item mode="md" lines="none" color="transparent">
      <ion-label
        mode="md"
        color="status-icon-enable"
        class="label-password-format"
      >
        <ion-text mode="md">
          <ion-icon
            [color]="isPasswordEqual.color"
            [name]="isPasswordEqual.name"
            mode="md"
            class="ellipse-sharp"
          ></ion-icon>
          {{ "Labels.passwords-match" | translate }}
        </ion-text>
      </ion-label>
    </ion-item>
  </ion-row>
</form>
